import { holdingEntityBackgroundColors } from './background-colors/holding-entity-background-colors';
import { ColorSelectionWrapper, HoldingEntityColorsInputTitle, SelectionContainer, HoldingEntityImageTile, HoldingEntityImageTileSelectedIconWrapper } from '../../../../modules/entities/EditHoldingEntity/EditHoldingEntity.styles';

export const HoldingEntityColorPicker = ({ holdingEntityData, onChangeColor, isMobileView = false }) => {
    return (
        <ColorSelectionWrapper>
            <HoldingEntityColorsInputTitle>Color</HoldingEntityColorsInputTitle>
            <SelectionContainer>
                {holdingEntityBackgroundColors.map((bgColor, index) => (
                    <HoldingEntityImageTile
                        key={index}
                        image={bgColor}
                        size={isMobileView ? 54 : 44}
                        isSelected={holdingEntityData.colorCode === bgColor}
                        onClick={() => onChangeColor(bgColor)}
                        isSelectable
                    >
                        {
                            (holdingEntityData.colorCode === bgColor) &&
                            <HoldingEntityImageTileSelectedIconWrapper>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="11" viewBox="0 0 13 11" fill="none">
                                    <path d="M11.5105 1.604L4.50597 8.6125L0.999953 5.10754" stroke="black" stroke-width="2" />
                                </svg>
                            </HoldingEntityImageTileSelectedIconWrapper>
                        }
                    </HoldingEntityImageTile>
                ))}
            </SelectionContainer>
        </ColorSelectionWrapper>
    )
}